import { colors } from "../../Styles";

export function Dot({ size = "6px", color = colors.greyDarkPrimary, pulse = false }) {
  const numericSize = parseFloat(size);
  const radius = numericSize / 2;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${numericSize} ${numericSize}`}>
      <circle cx={radius} cy={radius} r={radius} fill={color}>
        {pulse && (
          <animate
            attributeName="opacity"
            values="0.5;1;0.5"
            dur="2s"
            repeatCount="indefinite"
          />
        )}
      </circle>
    </svg>
  );
}